<template>
    <!-- 抽奖项目详情 -->
    <div>
        <el-dialog
            title="更多设置"
            :visible.sync="dialogVisible"
            width="30%"
            center
            :close-on-click-modal='false'
            @close="handleClose">
        
        <el-row class="row">
            <el-col :span="6" class="title">
                标识符
            </el-col>
            <el-col :span="18">
                <el-input size="medium" v-model="tempData.tag" placeholder="奖品标识符[分组]，用于程序判断是否重复中奖" prefix-icon="el-icon-info"></el-input>
            </el-col>
        </el-row>
        <el-row class="row">
            <el-col :span="6" class="title">
                奖品名
            </el-col>
            <el-col :span="18">
                <el-input size="medium" v-model="tempData.name" placeholder="奖品名称" prefix-icon="el-icon-suitcase"></el-input>
            </el-col>
        </el-row>
        <el-row class="row">
            <el-col :span="6" class="title">
                每日数量
            </el-col>
            <el-col :span="18">
                 <el-input-number style="width:100%;" v-model="tempData.day_count" placeholder="此奖品每天最多抽出量，默认为不限制" :step="1" :min="0"></el-input-number>
            </el-col>
        </el-row>
        <el-row class="row">
            <el-col :span="6" class="title">
                总数量
            </el-col>
            <el-col :span="18">
                <el-input-number style="width:100%;" v-model="tempData.count" placeholder="此奖品总共最多抽出量，默认为不限制" :step="1" :min="0"></el-input-number>
            </el-col>
        </el-row>
        <el-row class="row">
            <el-col :span="6" class="title">
                概率
            </el-col>
            <el-col :span="18">
                <el-input-number style="width:100%;" v-model="tempData.ratio" placeholder="每多少人能抽中一次" :step="1" :min="0"></el-input-number>
            </el-col>
        </el-row>
        <el-row class="row">
            <el-col :span="6" class="title">
                随机方式
            </el-col>
            <el-col :span="18" class="title">
                <el-tooltip class="item" effect="dark" content="相对随机:表示每多少人必然就有一人中奖" placement="top">
                    <el-switch active-text="相对随机" inactive-text="绝对随机" v-model="tempData.abs_rand"> </el-switch>
                </el-tooltip>
            </el-col>
        </el-row>
        <el-row class="row">
            <el-col :span="12"> 
                <el-col :span="10" class="title">
                    重复中奖
                </el-col>
                <el-col :span="14" class="title">
                    <el-tooltip class="item" effect="dark" content="设置此奖品是否可以被同一个重复抽中" placement="top">
                        <el-switch v-model="tempData.repeat"></el-switch>
                    </el-tooltip>
                </el-col>
            </el-col>
            <el-col :span="12">
                <el-col :span="10" class="title">
                    必中备选
                </el-col>
                <el-col :span="14" class="title">                        
                    <el-tooltip class="item" effect="dark" content="如果设置了当日最大中奖次数，此选项为必中奖品选项之一" placement="top">
                        <el-switch v-model="tempData.can_be"></el-switch>
                    </el-tooltip>
                </el-col>
            </el-col>
        </el-row>
        <el-row class="row">
            <el-col :span="6" class="title">
                使用级别
            </el-col>                
            <el-col :span="18" class="title">
                <el-tooltip class="item" effect="dark" content="设置抽奖级别，用户冲关类型抽奖" placement="top">
                        <el-switch v-model="tempData.use_level"> </el-switch>
                </el-tooltip>
            </el-col>
        </el-row>
        <el-row class="row" v-if="tempData.use_level">
            <el-col :push='1' :span="6" class="title">
                奖品级别
            </el-col>
            <el-col :span="18" class="title">
                <el-input-number style="width:100%;" v-model="tempData.level" :step="1" :min="0"></el-input-number>
            </el-col>
        </el-row>
        <el-row class="row" v-if="tempData.use_level">
            <el-col :push='1' :span="6" class="title">
                级别判断
            </el-col>
            <el-col :span="18" class="title">
                <el-input size="medium" v-model="tempData.level_script" placeholder="请填写级别过滤判断脚本,比如：<=1" prefix-icon="el-icon-cpu"></el-input>
            </el-col>
        </el-row>
        <el-row class="row">
            <el-col :span="6" class="title">
                奖品类别
            </el-col>
            <el-col :span="18" class="title">                    
                <el-tooltip class="item" effect="dark" content="设置抽奖类别，默认不设置，包括红包，话费等" placement="top">
                    <el-select v-model="tempData.catgory" placeholder="请选择" style='width:100%'>
                        <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-tooltip>
            </el-col>
        </el-row>
        <el-row class="row" v-if="tempData.catgory > 0">
            <el-col :push='1' :span="6" class="title">
                金额
            </el-col>
            <el-col :span="18" class="title">
                <el-input-number style="width:100%;" placeholder='奖品金额' v-model="tempData.money" :step="1" :min="0"></el-input-number>
            </el-col>
        </el-row>
        <el-row class="row" v-if="tempData.catgory > 0">
            <el-col :push='1'  :span="6" class="title">
                立刻充值
            </el-col>
            <el-col :span="18" class="title">
                <el-tooltip class="item" effect="dark" content="打开此选项后，如果中奖将立即充值" placement="top">
                    <el-switch v-model="tempData.money_go"> </el-switch>
                </el-tooltip>
            </el-col>
        </el-row>

        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="done">确 定</el-button>
        </span>
      </el-dialog>        
    </div>
</template>

<script>
import { cloneDeep } from 'lodash'
export default {
    props: {
        itemIndex: {
            type: Number,
            default: 0,
        },
        item: {
            type: Object,
            default: {
            }
        },
        visiable: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
           dialogVisible: this.visiable,
           tempData: {},
           options: [
               {label: '无', value:0},
               {label: '话费(暂不支持)', value:1},
               {label: '红包(暂不支持)', value:2},
           ]
        }
    },
    methods: {
        handleClose() {
            this.$emit('close')
        },        
        done() {
            this.$emit('done', this.itemIndex, this.tempData)
            this.dialogVisible = false
        },
        beforeClose(done) {
            this.$confirm('确认关闭？')
            .then(_ => {
                done();
            })
            .catch(_ => {});
        }
    },
    watch: {
        visiable(val) {
            this.dialogVisible = val

            if(val) {
                let item = {}
                for(let key in this.item) {
                    if(typeof(this.item[key]) === 'function') {
                        continue
                    }
                    item[key] = this.item[key]
                }

                this.tempData = cloneDeep(item)
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.title {
    line-height: 35px;
    margin: 0 auto;
}

.row {
    margin: 5px 0;
}

.dialog-footer {
    right: 10px;
}
</style>